import { useQuery, UseQueryOptions } from 'react-query';

import { StructureTranches, TermSheetFacilityMatchDrillIn, Tier1BankTypes } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';
import { GetStructureTrancheValue, GetTier1BankTypeValue } from '../../utils/enum';

export function useMatchingTermSheetFacilitiesQuery(
	guid: string | undefined,
	structure: StructureTranches | undefined,
	tier1: Tier1BankTypes | undefined,
	options?:
		| Omit<
				UseQueryOptions<TermSheetFacilityMatchDrillIn[], unknown, TermSheetFacilityMatchDrillIn[]>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();
	const structureValue = GetStructureTrancheValue(structure);
	const tier1Value = GetTier1BankTypeValue(tier1);
	const url = CerebroApiEndpoints.Matching.TermSheets(guid, structureValue, tier1Value);

	return useQuery(
		QueryKeys.Matching.TermSheets(guid, structureValue, tier1Value),
		() => AxiosUtils.getResponseData<TermSheetFacilityMatchDrillIn[]>(api.get(url)),
		options
	);
}
